<script setup>
import {onMounted} from "vue";
import {useHead} from "@vueuse/head";

onMounted(() => {
  const scripts = [
    '/js/core.min.js',
    '/js/script.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);
})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})

</script>

<template>
  <div class="page">
    <section class="section section-single box-transform-wrap novi-background novi-background context-dark">
      <div class="section-single-inner">
        <header class="section-single-header page-header">
          <div class="container"><a href="/"><img src="/images/tpa3.png" alt="" width="223"
                                                           height="60"/></a></div>
        </header>
        <div class="section-single-main">
          <div class="container">
            <div class="title-modern">404</div>
            <h4 class="text-spacing-0 text-transform-none">Page Not Found</h4><a
              class="button button-lg button-primary button-winona" href="/">Go to home page</a>
          </div>
        </div>
        <div class="section-single-footer">
          <div class="container">
            <!-- Rights-->
            <p class="rights"><span>&copy;&nbsp;</span><span class="copyright-year"></span><span>&nbsp;</span><span>Tpa Housing</span></p>
          </div>
        </div>
      </div>
      <div class="box-transform" style="background-image: url(/images/bg-404.jpg);"></div>
    </section>
  </div>
  <!-- Global Mailform Output-->
  <div class="snackbars" id="form-output-global"></div>
</template>

<style scoped lang="scss">

</style>